const STAGE_COLORS = { SIGNED_UP: 'bg-blue-500', CONNECTED: 'bg-cyan-500', ACTIVE: 'bg-green-500', GOOD_CUSTOMER: 'bg-purple-500', CHURNED: 'bg-red-500' };
const STAGE_LABELS = { SIGNED_UP: 'Signed Up', CONNECTED: 'Connected', ACTIVE: 'Active', GOOD_CUSTOMER: 'Good Customer', CHURNED: 'Churned' };

export default function FunnelChart({ stats, selectedStage, onStageClick }) {
  const stages = ['SIGNED_UP', 'CONNECTED', 'ACTIVE', 'GOOD_CUSTOMER', 'CHURNED'];
  const stageValues = { SIGNED_UP: stats.signedUp || 0, CONNECTED: stats.connected || 0, ACTIVE: stats.active || 0, GOOD_CUSTOMER: stats.goodCustomer || 0, CHURNED: stats.churned || 0 };
  const total = Object.values(stageValues).reduce((a, b) => a + b, 0) || 1;

  return (
    <div className="flex gap-2 mb-6">
      {stages.map(stage => (
        <button key={stage} onClick={() => onStageClick(stage)}
          className={`flex-1 p-4 rounded-lg border-2 transition-all ${selectedStage === stage ? 'border-gray-800 shadow-md' : 'border-transparent hover:border-gray-300'}`}>
          <div className={`text-2xl font-bold ${STAGE_COLORS[stage].replace('bg-', 'text-')}`}>{stageValues[stage]}</div>
          <div className="text-xs text-gray-600 mt-1">{STAGE_LABELS[stage]}</div>
          <div className="mt-2 h-1 rounded-full bg-gray-200">
            <div className={`h-full rounded-full ${STAGE_COLORS[stage]}`} style={{ width: `${(stageValues[stage] / total) * 100}%` }} />
          </div>
        </button>
      ))}
    </div>
  );
}
